<template>
  <div class="tags-box">
    <!-- <Tag
      class="tag-item--mark"
      :color="currentPath == route.path ? 'blue' : 'gray'"
      :type="currentPath !== route.path ? 'border' : ''"
      v-for="(route) in routeMap.children"
      :key="route.name"
      @click="handleTag(route)">{{ route.meta.title }}</Tag> -->
    <li class="tag-item"
      v-for="(route) in routeMap.children"
      :data-sel="currentPath == route.path ? 'true' : 'false'"
      v-if="showTag(route)"
      :key="route.name"
      @click="handleTag(route)"> {{ getRouteTitle(route.name) }}</li>
  </div>
</template>
<script>
import { visionRouteList } from '@/router/routers.js';
import { findRouteByName } from '@/libs/util';
import api from '@/api';
import langMap from '@/utils/language';
import { mapState } from 'vuex';
// 保存已经打开的窗口对象
let windowMap = {};


export default {
  data() {
    return {
      currentPath: '',
      routeMap: {},
      parentWindow:window.opener
    }
  },
  computed: {
    ...mapState({
      sysMenulist: state => state.app.sysMenulist,
      lang: state => state.app.language
    })
  },
  methods: {
     // 添加获取路由标题的方法
     getRouteTitle(name) {
      const route = findRouteByName(this.sysMenulist, name);
      return route ? route.title : name;
    },
    initTags(path) {
      const currentRoute = path || this.$route.path;
      const paths = currentRoute.split('/');
      this.currentPath = paths[paths.length-1];

      let _path = paths[1];
      // 查询当前所用的主路由项
      visionRouteList.some(route => {
        if ('/' + _path === route.path) {
          this.routeMap = route;

          return true;
        }
      })
    },
    async handleTag(route) {
      if (route && (route.name === 'workData' || route.name === 'workVideo')) {
        const hasSelectedRobot = await this.checkHasSelectedRobot();
        if (!hasSelectedRobot) {
          this.$Notice.warning({
            title: langMap.tip[this.lang],
            desc: langMap.workVisionPleaseSelectRobot[this.lang]
          });
          return;
        }
      }

      const _path = route.path;
      if (_path === this.currentPath) return;

      const windowCase = windowMap[_path];
      if (windowCase) {
        let winHash = windowCase.location.hash;
        // 未关闭且路由未改变情况
        if (!windowCase.closed && winHash.indexOf(_path) !== -1) {
          windowMap[_path].focus();
          return;
        }
      }
      // 已关闭、初次打开、路由已改变情况
      windowMap[_path] = window.open(`${window.location.origin}/#${this.routeMap.path}/${_path}`);
      // 已存在情况则直接获得焦点即可
      windowMap[_path].focus();

    },
    async checkHasSelectedRobot() {
      try {
        const res = await api.getData('notice-server/usr/robot/list', this);
        return res && res.state === 1 && Array.isArray(res.data) && res.data.length > 0;
      } catch (e) {
        return false;
      }
    },
    showTag(route) {
      if (!window.opener) return true;
      else if (this.currentPath == route.path) return true;
      else return false;
    }
  },
  created() {
    this.initTags();
  }
}
</script>
<style scoped lang="less">
.tags-box{
  display: flex;
  padding: 0;
  flex-direction: row;
  flex-wrap: nowrap;
  list-style: none;
  list-style-type: none;
  .tag-item{
    list-style: none;
    list-style-type: none;
    height: 100%;
    padding: 5px 20px;
    font-size: 14px;
    text-align: center;
    background-color: #f8f8f9;
    margin-right: 2px;
    cursor: pointer;
    &:hover{
      color: #2F74FF;
    }
    &[data-sel~=true]{
      background-color: #2F74FF;
      color: white !important;
    }
  }
  .tag-item--mark{
    font-size: 16PX;
  }
}
</style>
